export default __webpack_public_path__ + "locales/pt-BR/Files.json?hash=9e2c390b7940b3f2e46396f2a58d92ee";